const apps = {
  apps: "приложений",
  sections: "разделов",
  searchPlaceholder: "Поиск приложений...",
  all: "Все",
  noApps: "Нет приложений в реестре",
  status: {
    built: "Готово",
    inProgress: "В разработке",
    planned: "Запланировано",
    idea: "Идея",
  },
} as const;

export default apps;